module.exports = __webpack_public_path__ + "media/img/logos/2023/valentine-6be4689eb87cbc851ef06d26a5d0e81a.svg";